"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldContext = void 0;
var react_1 = require("react");
exports.FieldContext = (0, react_1.createContext)({
    isField: false,
});
